import React from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { BannerImage } from "./BackEnd/Masters/BannerImage/BannerImage";
import { TopBrand } from "./BackEnd/Masters/TopBrand/TopBrand";
import { Promotion } from "./BackEnd/Masters/Promotion/Promotion";
import { BannerImageList } from "./BackEnd/Masters/BannerImage/BannerImageList";
import { TopBrandList } from "./BackEnd/Masters/TopBrand/TopBrandList";
import { PromotionList } from "./BackEnd/Masters/Promotion/PromotionList";
import DigitalCardManagement from "./BackEnd/Masters/DigitalCard/DigitalCard";
import { Product } from "./BackEnd/Masters/Products/Product";
import { ProductList } from "./BackEnd/Masters/Products/ProductList";
import RewardRule from "./BackEnd/Masters/Loyalty/RewardRule";
import { RewardRuleList } from "./BackEnd/Masters/Loyalty/RewardRuleList";
import LoyaltyDashboard from "./BackEnd/Dashboard/LoyaltyDashboard";
import RedeemReward from "./BackEnd/Masters/Loyalty/Redeem";
import { UserList } from "./BackEnd/Masters/UserRegistration/UserRegistrationList";
import User from "./BackEnd/Masters/UserRegistration/UserRegistration";
import ProtectedRoute from "./ProtectedRoute";

interface PrivateRouteProps {
  token: string | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ token }) => {
  if (!token) {
    return token ? <Outlet /> : <Navigate to="/login" />;
  }

  return (
    <Routes>
      {/* Public routes accessible to all authenticated users */}
      <Route path="/home" element={<LoyaltyDashboard />} />
      
      <Route
        path="/reward/rule/list"
        element={<RewardRuleList />}
      />
      <Route
        path="/reward/rule/create"
        element={<RewardRule />}
      />
      <Route
        path="/reward/rule/:id"
        element={<RewardRule />}
      />
      <Route
        path="/reward/redeem"
        element={<RedeemReward />}
      />

      {/* card management */}
      <Route path="/digital/card" element={<DigitalCardManagement />} />

      {/* Admin only routes */}
      <Route
        path="/banner/list"
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <BannerImageList id="bannerList" />
          </ProtectedRoute>
        }
      />
      <Route 
        path="banner/create" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <BannerImage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/banner/:id" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <BannerImage />
          </ProtectedRoute>
        } 
      />

      {/* brand management - admin only */}
      <Route 
        path="/brand/list" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <TopBrandList id="brandList" />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="brand/create" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <TopBrand />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/brand/:id" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <TopBrand />
          </ProtectedRoute>
        } 
      />

      {/* offer management - admin only */}
      <Route
        path="/promotion/list"
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <PromotionList id="promotionList" />
          </ProtectedRoute>
        }
      />
      <Route 
        path="promotion/create" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <Promotion />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/promotion/:id" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <Promotion />
          </ProtectedRoute>
        } 
      />

      {/* product management - admin only */}
      <Route
        path="/product/list"
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <ProductList id="productList" />
          </ProtectedRoute>
        }
      />
      <Route 
        path="product/create" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <Product />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/product/:id" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <Product />
          </ProtectedRoute>
        } 
      />

      {/* user management - admin only */}
      <Route 
        path="/user/list" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <UserList />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/user/:id?" 
        element={
          <ProtectedRoute token={token} allowedRoles={['admin']}>
            <User />
          </ProtectedRoute>
        } 
      />

      {/* Catch all route - redirect to home */}
      <Route path="*" element={<Navigate to="/home" replace />} />
    </Routes>
  );
};

export default PrivateRoute;
